import { MenuItem, Stack, TextField } from '@mui/material';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { FormTextField } from 'src/components/Forms/FormTextField/form-text-field';
import {
  BLOCK_SHORT_TEXTAREA_PROPS,
  BLOCK_TEXT_FIELD_PROPS,
} from 'src/pages/Settings/memberships/components/landing-page-tab/block-fields/field-props';
import { ImageUrlField } from 'src/pages/Settings/memberships/components/landing-page-tab/block-fields/image-url-field';
import {
  blockFieldName,
  type LandingPageFormValues,
} from 'src/pages/Settings/memberships/components/landing-page-tab/types';

const MEDIA_KINDS = [
  { value: 'none', label: 'No media' },
  { value: 'image', label: 'Image' },
  { value: 'video', label: 'Video' },
];

interface HeroBlockFieldsProps {
  index: number;
  readOnly: boolean;
}

export const HeroBlockFields = ({ index, readOnly }: HeroBlockFieldsProps) => {
  const { control } = useFormContext<LandingPageFormValues>();
  const mediaKind = useWatch({ control, name: blockFieldName(index, 'heroMediaKind') });

  return (
    <Stack gap={2.5}>
      <FormTextField
        type="textfield"
        name={blockFieldName(index, 'heroHeadline')}
        label="Headline"
        required="Headline is required"
        disabled={readOnly}
        textFieldProps={BLOCK_TEXT_FIELD_PROPS}
        description="Wrap words in *asterisks* to accent them."
      />

      <FormTextField
        type="textfield"
        name={blockFieldName(index, 'heroSubtext')}
        label="Subtext"
        disabled={readOnly}
        textFieldProps={BLOCK_SHORT_TEXTAREA_PROPS}
      />

      <Controller
        name={blockFieldName(index, 'heroMediaKind')}
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            select
            label="Media"
            size="small"
            fullWidth
            disabled={readOnly}
          >
            {MEDIA_KINDS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        )}
      />

      {mediaKind === 'image' ? (
        <ImageUrlField
          name={blockFieldName(index, 'heroImageUrl')}
          label="Image URL"
          readOnly={readOnly}
        />
      ) : null}

      {mediaKind === 'video' ? (
        <Stack gap={2.5}>
          <FormTextField
            type="textfield"
            name={blockFieldName(index, 'heroVideoUrl')}
            label="Video URL"
            disabled={readOnly}
            textFieldProps={BLOCK_TEXT_FIELD_PROPS}
          />
          <FormTextField
            type="textfield"
            name={blockFieldName(index, 'heroVideoTitle')}
            label="Video title"
            disabled={readOnly}
            textFieldProps={BLOCK_TEXT_FIELD_PROPS}
          />
          <FormTextField
            type="textfield"
            name={blockFieldName(index, 'heroVideoCaption')}
            label="Video caption"
            disabled={readOnly}
            textFieldProps={BLOCK_TEXT_FIELD_PROPS}
          />
        </Stack>
      ) : null}
    </Stack>
  );
};
